import { Component, EventEmitter, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';

@Component({
  selector: 'app-delete-icon-button',
  standalone: false,
  templateUrl: './delete-icon-button.component.html',
})
export class DeleteIconButtonComponent extends AppBaseComponent {
  @Output() triggered = new EventEmitter<void>();

  onClick(): void {
    this.triggered.emit();
  }
}
